// frontend/src/components/flight/FlightFilters.jsx
import React from 'react';

const FlightFilters = ({ filters, onFiltersChange, flights }) => {
  const handleFilterChange = (key, value) => {
    onFiltersChange({ [key]: value });
  };

  const priceRange = flights.length > 0 ? {
    min: Math.min(...flights.map(f => f.base_price)),
    max: Math.max(...flights.map(f => f.base_price))
  } : { min: 0, max: 1000 };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold mb-4">Filter Flights</h3>
      
      <div className="space-y-6">
        {/* Sort By */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Sort By
          </label>
          <select
            value={filters.sortBy}
            onChange={(e) => handleFilterChange('sortBy', e.target.value)}
            className="w-full input"
          >
            <option value="price">Price (Low to High)</option>
            <option value="duration">Duration (Shortest)</option>
            <option value="departure_time">Departure Time</option>
          </select>
        </div>

        {/* Price Range */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Price Range
          </label>
          <div className="grid grid-cols-2 gap-2">
            <input
              type="number"
              placeholder="Min"
              value={filters.minPrice}
              onChange={(e) => handleFilterChange('minPrice', e.target.value)}
              className="input"
              min={priceRange.min}
              max={priceRange.max}
            />
            <input
              type="number"
              placeholder="Max"
              value={filters.maxPrice}
              onChange={(e) => handleFilterChange('maxPrice', e.target.value)}
              className="input"
              min={priceRange.min}
              max={priceRange.max}
            />
          </div>
          <div className="text-xs text-gray-500 mt-1">
            ${priceRange.min} - ${priceRange.max}
          </div>
        </div>

        {/* Duration */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Max Duration (hours)
          </label>
          <input
            type="number"
            placeholder="Any"
            value={filters.maxDuration ? filters.maxDuration / 60 : ''}
            onChange={(e) => handleFilterChange('maxDuration', e.target.value ? e.target.value * 60 : '')}
            className="input"
            min="1"
            max="24"
          />
        </div>

        {/* Stops */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Max Stops
          </label>
          <select
            value={filters.maxStops}
            onChange={(e) => handleFilterChange('maxStops', e.target.value)}
            className="input"
          >
            <option value="">Any</option>
            <option value="0">Direct Only</option>
            <option value="1">Up to 1 Stop</option>
            <option value="2">Up to 2 Stops</option>
          </select>
        </div>

        {/* Clear Filters */}
        <button
          onClick={() => onFiltersChange({
            minPrice: '',
            maxPrice: '',
            maxDuration: '',
            maxStops: '',
            sortBy: 'price'
          })}
          className="w-full btn btn-secondary text-sm"
        >
          Clear All Filters
        </button>
      </div>
    </div>
  );
};

export default FlightFilters;
